import { motion } from "framer-motion";
import StoreBadges from "./StoreBadges";

export default function DownloadCTA() {
  return (
    <section
      id="telecharger"
      data-testid="download-cta-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative rounded-[40px] overflow-hidden border border-white/10 px-6 py-16 sm:px-16 sm:py-24 text-center"
          style={{
            background:
              "radial-gradient(ellipse 100% 100% at 50% 0%, rgba(157,76,221,0.35) 0%, rgba(30,11,54,0.6) 40%, rgba(11,5,20,0.9) 100%)",
          }}
        >
          {/* Ambient glows */}
          <div
            aria-hidden="true"
            className="absolute -top-32 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full bg-[#9D4CDD]/30 blur-[120px]"
          />
          <div
            aria-hidden="true"
            className="absolute -bottom-24 right-10 w-[300px] h-[300px] rounded-full bg-[#B47CE8]/20 blur-[100px]"
          />

          <div className="relative">
            <h2
              data-testid="cta-title"
              className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight text-white leading-[1.05] mb-4"
            >
              Télécharge Echo <br className="hidden sm:block" />
              dès maintenant
            </h2>
            <p
              data-testid="cta-subtitle"
              className="text-lg sm:text-xl text-white/70 font-medium mb-10 max-w-xl mx-auto"
            >
              Et Glow Up Mentalement.
            </p>

            <StoreBadges testidPrefix="cta" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
